<section class="information-area ptb-100 bg-mandish">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="information-image text-center">
                    <img src="assets/img/jam-min.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="information-content">
                    <span class="sub-title" i18n>Information</span>
                    <h2 i18n>How We Implement Our Projects?</h2>
                    <ul class="apply-details">
                        <li>
                            <div class="icon">
                                <i class="flaticon-checkmark"></i>
                            </div>
                            <h3 i18n>Assessing Needs for Historical Asset Preservation</h3>
                            <p i18n>Comprehensive identification and prioritization of historical assets requiring restoration, conservation, consolidation, or revitalization for optimal preservation and community benefit.</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="flaticon-login"></i>
                            </div>
                            <h3 i18n>Historical Context and Current Status Assessment of [Specific Subject/Area]</h3>
                            <p i18n>Conduct a comprehensive assessment and analysis of the historical context and current status of [Specific Subject/Area].</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="flaticon-credit-card"></i>
                            </div>
                            <h3 i18n>Collaborative Project Planning</h3>
                            <p i18n>Developing a comprehensive and integrated project plan in close collaboration with relevant stakeholders and partner organizations.</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="flaticon-verify"></i>
                            </div>
                            <h3 i18n>Effective Project Execution and Reporting</h3>
                            <p i18n>Implementing the project plan effectively, conducting rigorous monitoring and evaluation throughout the project lifecycle, and providing comprehensive and timely progress reports to all relevant stakeholders.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>